// Generated by ReScript, PLEASE EDIT WITH CARE

import * as ReactGa4 from "react-ga4";

function publishGaEvent(payload) {
  ReactGa4.default.send(payload);
}

function publishGaEventParameter(event_name, payload) {
  ReactGa4.default.event(event_name, payload);
}

export {
  publishGaEvent ,
  publishGaEventParameter ,
}
/* react-ga4 Not a pure module */
